var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftGrayArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 52,
    viewBox: "0 0 27 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74426 26.0002L25.9743 47.8177C26.149 47.9936 26.2872 48.2023 26.3808 48.4319C26.4744 48.6615 26.5215 48.9073 26.5195 49.1552C26.5174 49.4031 26.4662 49.6482 26.3688 49.8762C26.2714 50.1042 26.1298 50.3106 25.9521 50.4835C25.7744 50.6564 25.5642 50.7923 25.3336 50.8834C25.1031 50.9745 24.8567 51.019 24.6088 51.0143C24.361 51.0096 24.1165 50.9558 23.8896 50.8559C23.6626 50.7561 23.4577 50.6123 23.2868 50.4327L0.786757 27.3077C0.446202 26.9577 0.255661 26.4886 0.255661 26.0002C0.255661 25.5119 0.446202 25.0428 0.786757 24.6927L23.2868 1.56774C23.4577 1.38821 23.6626 1.24437 23.8896 1.14454C24.1165 1.04472 24.361 0.990887 24.6088 0.986168C24.8567 0.981449 25.1031 1.02593 25.3336 1.11705C25.5642 1.20817 25.7744 1.3441 25.9521 1.51699C26.1298 1.68989 26.2714 1.89631 26.3688 2.1243C26.4662 2.35229 26.5174 2.59734 26.5195 2.84525C26.5215 3.09316 26.4744 3.33902 26.3808 3.5686C26.2872 3.79818 26.149 4.00692 25.9743 4.18274L4.74426 26.0002Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftGrayArrow);
export default __webpack_public_path__ + "static/media/left_gray_arrow.7decda00ecedd3c0d173e41f1c3fe071.svg";
export { ForwardRef as ReactComponent };